'use client';
import { useMemo, useState } from 'react';
import { MeetingMsgItem } from '../type';
import { useLocale } from 'use-intl';
import { getCMSIntlVal } from '../utils/common';
import ButtonPaging from '../component/ButtonPaging';
import Image from '../../../image';

const MessageInfoItem = ({
  item,
  className,
}: {
  item: MeetingMsgItem;
  className: string;
}) => {
  const locale = useLocale();
  const { imgUrl, time, link } = item || {};
  const title = getCMSIntlVal(item, 'title', locale);
  return (
    <div
      className={`py-4 px-6 flex items-center justify-between text-[#121C59] font-300 cursor-pointer hover:font-400 hover:text-[#1C3FF0] hover:bg-[#FFFFFF66] ${className}`}
      onClick={() => {
        window.open(link, '_blank');
      }}
    >
      <div className="flex-1">
        <div className="text-[28px] leading-[1.5] break-all line-clamp-3">
          {title}
        </div>
        <div className="text-[24px] leading-[1.5] font-300 mt-5 opacity-60 font-tcn">
          {time}
        </div>
      </div>
      <Image
        src={imgUrl}
        loading="lazy"
        width={285}
        height={160}
        className="w-[285px] h-[160px] flex-shrink-0 ml-20"
        alt={'Message Image'}
      ></Image>
    </div>
  );
};

const MessageInfo = ({
  list,
  className,
}: {
  list: MeetingMsgItem[];
  className: string;
}) => {
  const [page, setPage] = useState(1);
  const [isFading, setIsFading] = useState(false);
  const pageSize = 3;

  const total = useMemo(() => {
    return Math.ceil(list.length / pageSize);
  }, [list.length, pageSize]);

  const renderList = useMemo(() => {
    return list.slice((page - 1) * pageSize, page * pageSize);
  }, [list, page]);

  const handlePageChange = (newPage: number) => {
    setIsFading(true);
    setTimeout(() => {
      setPage(newPage);
      setTimeout(() => {
        setIsFading(false);
      }, 50);
    }, 300);
  };

  return (
    <div className={`w-full ${className}`}>
      <div
        className={`w-full grid grid-rows-3 transition-opacity duration-300 ${
          isFading ? 'opacity-0' : 'opacity-100'
        }`}
      >
        {renderList.map((item, index) => (
          <MessageInfoItem
            item={item}
            key={index}
            className="flex-shrink-0"
          ></MessageInfoItem>
        ))}
      </div>
      <ButtonPaging
        page={page}
        next={() => handlePageChange(page + 1)}
        prev={() => handlePageChange(page - 1)}
        total={total}
      ></ButtonPaging>
    </div>
  );
};

export default MessageInfo;
